document.addEventListener('DOMContentLoaded', function() {
  document.querySelectorAll('.color-swatch').forEach(swatch => {
    swatch.addEventListener('click', function(e) {
      e.preventDefault();

      const variantId = this.dataset.variantId;
      const productHandle = this.dataset.productHandle;
      const productCard = this.closest('.card-wrapper');
      const mediaContainer = productCard.querySelector('.media');
      
      if (!mediaContainer) return;

      // Simpan referensi ke semua elemen media
      const mainImg = mediaContainer.querySelector('img:first-child');
      const hoverMedia = mediaContainer.querySelector('img:nth-child(2), rollover-video');
      
      // 1. Update active state dan nama warna
      productCard.querySelectorAll('.color-swatch').forEach(s => s.classList.remove('active'));
      this.classList.add('active');
      
      const colorNameContainer = productCard.querySelector('.selected-color-name');
      if (colorNameContainer) {
        colorNameContainer.textContent = this.getAttribute('title');
      }

      // 2. Gunakan sistem gambar variant Shopify yang benar
      fetch(`/products/${productHandle}?view=variant-images&variant=${variantId}`)
        .then(response => {
          if (!response.ok) throw new Error('Network response was not ok');
          return response.text();
        })
        .then(html => {
          const parser = new DOMParser();
          const doc = parser.parseFromString(html, 'text/html');
          const variantImages = doc.querySelectorAll('.media img');
          
          // Debugging
          console.log('Variant images found:', variantImages.length);
          
          if (variantImages.length > 0 && mainImg) {
            // Backup sumber gambar asli
            if (!mainImg.dataset.originalSrc) {
              mainImg.dataset.originalSrc = mainImg.src;
              mainImg.dataset.originalSrcset = mainImg.srcset;
            }
            
            // Update gambar utama
            mainImg.src = variantImages[0].src;
            mainImg.srcset = variantImages[0].srcset || variantImages[0].src;
            
            // Jika ada gambar hover dan variant memiliki gambar kedua
            if (hoverMedia && hoverMedia.tagName === 'IMG' && variantImages[1]) {
              hoverMedia.src = variantImages[1].src;
              hoverMedia.srcset = variantImages[1].srcset || variantImages[1].src;
            }
          }
        })
        .catch(error => {
          console.error('Error fetching variant:', error);
          // Fallback 1: Coba ambil dari product.json
          fetch(`/products/${productHandle}.js`)
            .then(response => response.json())
            .then(product => {
              const variant = product.variants.find(v => v.id == variantId);
              if (variant && variant.featured_image) {
                mainImg.src = variant.featured_image.src;
                mainImg.srcset = `${variant.featured_image.src} 1x`;
              }
            })
            .catch(() => {
              // Fallback 2: Kembalikan ke gambar asli
              if (mainImg.dataset.originalSrc) {
                mainImg.src = mainImg.dataset.originalSrc;
                mainImg.srcset = mainImg.dataset.originalSrcset;
              }
            });
        });
    });
  });
});